export const MONTHS = 'MONTHS';
export const DAYS = 'DAYS';
export const HOURS = 'HOURS';
export const MINUTES = 'MINUTES';
export const SECONDS = 'SECONDS';
export const COLON_KEY = 'colon';
export const TIMER_ROLE = 'timer';
export const COUNTDOWN_ARIA_LABEL = 'Campaign Remaining Time';
